import { AlertTriangle } from "src/assets/mapfre-icons-components";
import { CaptionMLow, CaptionMLowMedium } from "../ui/typographic";

export const PreAuthByGatewayCard = ({
  title,
  message,
}: {
  title: string | undefined;
  message: string | undefined;
}) => {
  return (
    <div className="border-state-notice-1 flex overflow-hidden rounded-sm border">
      <div className="bg-bg-notice-1 flex items-center justify-center p-2 md:p-4">
        <AlertTriangle
          aria-hidden="true"
          className="text-state-notice-1 size-6 md:size-8"
        />
      </div>
      <div className="flex flex-col gap-1 p-4">
        <CaptionMLowMedium className="text-brand-blue-1 font-bold">
          {title}
        </CaptionMLowMedium>
        <CaptionMLow className="text-brand-blue-1">{message}</CaptionMLow>
      </div>
    </div>
  );
};
